import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlSanitizer'
})
export class UrlSanitizerPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
